module.exports = __webpack_public_path__ + "static/media/house.c70699c8.svg";